import { Box, Loader, ModBox } from '@jfs/ui-new'
import { ButtonNew } from '../../../../components/AdminButton'
import { useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../../../data/store'
import { FiuStatusData } from '../../FiuStatus/comps/FiuStatusData'
import { FiuStatusStateIcon } from '../../FiuStatus/comps/FiuStatusStateIcon'
import { styles } from '../Checker'

const Footer = ({ onSubmit }: any) => {
  return <ButtonNew onPress={onSubmit} title={'Go to My Queue'} height={40} width={180} color={'PRIMARY'} />
}

const AadharRedactionStatus = ({ isCheckerApproved, data, onSubmit }) => {
  const {
    checkStatus,
    getApplicationApprovalstatus,
    checkerApplicationStatus,
    applicationRetry,
    applicationStatusFromApi,
    statusCallCount,
  } = useStores((store) => ({
    checkStatus: store.checkApplicationStatus,
    getApplicationApprovalstatus: store.getApplicationApprovalstatus(),
    checkerApplicationStatus: store.checkerApplicationStatus,
    applicationRetry: store.applicationRetry,
    applicationStatusFromApi: store.checkerApplicationStatus.applicationStatus,
    statusCallCount: store.checkerApplicationStatus.callCount,
  }))

  const [fetchCheckStatusApi, fetchCheckStatusApiHandler] = useLazyApiData(checkStatus)
  const [retryApi, applicationRetryHandler] = useLazyApiData(applicationRetry)

  const [approvedDate, setApprovedDate] = useState('')

  const [applicationStatus, setApplicationStatus] = useState(false)
  const [statusData, setStatusData] = useState({
    applicationStatus: data?.applicationStatus ?? '',
    applicationId: data?.applicationId ?? '',
    identificationNumber: data?.identificationNumber ?? '',
    inProgressTask: data?.inProgressTask ?? '',
    completedTaskList: data?.completedTaskList ?? [],
    errorReason: data?.errorReason ?? '',
    auditType: data?.auditType ?? '',
    errorTask: data?.errorTask ?? '',
    comments: data?.comments ?? '',
    createdBy: data?.createdBy ?? '',
    createdAt: data?.createAt ?? '',
  })

  const getLocaleDateString = () => {
    const date = new Date().toLocaleString()
    if (approvedDate === '' && approvedDate !== date) {
      setApprovedDate(date)
    }
    return date
  }

  const getErrorReason = (errorReason: any) => {
    try {
      return errorReason && JSON?.parse(errorReason)?.error?.message
    } catch (e) {
      return errorReason
    }
  }

  const onApplicationRetry = () => {
    if (statusData?.applicationId?.length > 0) {
      retryApi(statusData?.applicationId, true, 'AADHAR_REDACTION')
    }
  }

  useEffect(() => {
    if (approvedDate === '') {
      setApprovedDate(new Date().toLocaleString())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (data?.data?.applicationId?.length > 0) {
      fetchCheckStatusApi(data?.data?.applicationId, 'AADHAR_REDACTION')
    }
  }, [data, fetchCheckStatusApi])

  useEffect(() => {
    if (statusCallCount > 0) {
      console.log('applicationStatus: ', statusCallCount)
      setApplicationStatus(applicationStatusFromApi)
      if (checkerApplicationStatus?.applicationId?.length > 0) {
        setStatusData(checkerApplicationStatus)
      }
    }
  }, [applicationStatusFromApi, checkerApplicationStatus, statusCallCount, statusData?.applicationId])

  useEffect(() => {
    if (applicationRetryHandler?.state === 'fulfilled' || applicationRetryHandler?.state === 'rejected') {
      if (applicationRetryHandler?.state === 'fulfilled' && applicationRetryHandler?.data?.status === 'Success') {
        const applicationId = statusData?.applicationId
        if (applicationId?.length > 0) {
          setStatusData({
            applicationStatus: data?.applicationStatus ?? '',
            applicationId: data?.applicationId ?? '',
            identificationNumber: data?.identificationNumber ?? '',
            inProgressTask: data?.inProgressTask ?? '',
            completedTaskList: data?.completedTaskList ?? [],
            errorReason: data?.errorReason ?? '',
            auditType: data?.auditType ?? '',
            errorTask: data?.errorTask ?? '',
            comments: data?.comments ?? '',
            createdBy: data?.createdBy ?? '',
            createdAt: data?.createAt ?? '',
          })
          fetchCheckStatusApi(applicationId, 'AADHAR_REDACTION')
        }
      }
      if (applicationRetryHandler?.state === 'rejected') {
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    applicationRetryHandler.data?.status,
    applicationRetryHandler.state,
    data?.data?.applicationId,
    fetchCheckStatusApi,
  ])

  useEffect(() => {
    if (fetchCheckStatusApiHandler?.state === 'fulfilled') {
      if (fetchCheckStatusApiHandler?.data && fetchCheckStatusApiHandler?.data?.applicationStatus) {
        if (
          fetchCheckStatusApiHandler?.data?.applicationStatus?.toLowerCase() === 'completed' ||
          fetchCheckStatusApiHandler?.data?.applicationStatus?.toLowerCase() === 'error'
        ) {
          setStatusData(fetchCheckStatusApiHandler?.data)
        } else if (fetchCheckStatusApiHandler?.data?.applicationStatus?.toLowerCase() === 'rejected') {
          setStatusData(fetchCheckStatusApiHandler?.data)
        }
      }
    } else if (fetchCheckStatusApiHandler?.state === 'rejected') {
      setStatusData(fetchCheckStatusApiHandler?.data)
    }
  }, [fetchCheckStatusApiHandler?.data, fetchCheckStatusApiHandler?.state, statusData])

  useEffect(() => {
    if (
      getApplicationApprovalstatus &&
      getApplicationApprovalstatus.length > 0 &&
      getApplicationApprovalstatus === 'Error' &&
      statusData?.applicationId === ''
    ) {
    }
  }, [checkerApplicationStatus, getApplicationApprovalstatus, statusData, statusData?.applicationId])

  return (
    <>
      <>
        <ModBox show={fetchCheckStatusApiHandler?.state === 'pending' || applicationRetryHandler?.state === 'pending'}>
          <Loader />
        </ModBox>
      </>
      <ModBox
        {...styles.container}
        minHeight={620}
        show={fetchCheckStatusApiHandler?.state !== 'pending' || applicationRetryHandler?.state === 'pending'}>
        <Box alignItems={'center'} justifyContent={'center'} w={'100%'} h={'100%'}>
          <Box direction="row" alignItems={'center'}>
            <Box marginTop={64} alignItems={'center'} h={'100%'}>
              <Box direction="row">
                <FiuStatusStateIcon
                  isApproved={isCheckerApproved && statusData?.applicationStatus !== 'Rejected'}
                  show={
                    isCheckerApproved ||
                    statusData?.errorReason?.length === 0 ||
                    (statusData?.applicationStatus === 'Rejected' && statusData?.comments?.length > 0)
                  }
                  isProgress={false}
                  status={'completed'}
                />
                <FiuStatusData
                  isApproved={isCheckerApproved}
                  title={
                    isCheckerApproved && statusData?.applicationStatus !== 'Rejected'
                      ? 'Approved by checker'
                      : 'Rejected by checker'
                  }
                  subTitleKey={
                    isCheckerApproved && statusData?.applicationStatus !== 'Rejected'
                      ? 'Approved on: '
                      : 'Rejected on: '
                  }
                  subTitleValue={
                    isCheckerApproved &&
                    statusData?.applicationStatus !== 'Rejected' &&
                    statusData?.createdAt?.length > 0
                      ? statusData?.createdAt
                      : statusData?.applicationStatus === 'Rejected'
                      ? statusData?.createdAt
                      : getLocaleDateString()
                  }
                  subSubTitleKey={isCheckerApproved && statusData?.applicationStatus !== 'Rejected' ? '' : 'Comments: '}
                  subSubTitleValue={
                    isCheckerApproved && statusData?.applicationStatus !== 'Rejected' ? '' : statusData?.comments ?? ''
                  }
                  applicationId={statusData?.applicationId}
                  show={
                    isCheckerApproved ||
                    statusData?.errorReason?.length === 0 ||
                    (statusData?.applicationStatus === 'Rejected' && statusData?.comments?.length > 0)
                  }
                />
              </Box>
              <Box direction="row">
                <FiuStatusStateIcon
                  isApproved={
                    (statusData?.completedTaskList?.length > 0 &&
                      statusData?.completedTaskList?.includes('uploadRedactedFile')) ||
                    !(statusData?.errorTask === 'uploadRedactedFile' && statusData?.applicationStatus === 'Error')
                  }
                  show={
                    statusData?.completedTaskList?.includes('uploadRedactedFile') ||
                    statusData?.errorTask === 'uploadRedactedFile' ||
                    statusData?.inProgressTask === 'uploadRedactedFile'
                  }
                  isProgress={
                    statusData?.inProgressTask === 'uploadRedactedFile' &&
                    statusData?.errorTask !== 'uploadRedactedFile'
                  }
                  status={applicationStatus}
                />
                <FiuStatusData
                  isApproved={statusData?.completedTaskList?.includes('uploadRedactedFile') && isCheckerApproved}
                  title={
                    statusData?.completedTaskList?.includes('uploadRedactedFile') && isCheckerApproved
                      ? 'File Redacted Successfully'
                      : getErrorReason(statusData?.errorReason)
                  }
                  subTitleKey={'Uploading Redacted File Task : '}
                  subTitleValue={statusData?.identificationNumber}
                  subSubTitleKey={''}
                  subSubTitleValue={''}
                  show={
                    (statusData?.completedTaskList?.length > 0 &&
                      statusData?.completedTaskList?.includes('uploadRedactedFile')) ||
                    statusData?.errorTask === 'uploadRedactedFile' ||
                    statusData?.inProgressTask === 'uploadRedactedFile'
                  }
                />
              </Box>
            </Box>
          </Box>
          <ModBox marginTop={32} show={statusData?.errorReason?.length > 0 && statusData?.errorTask?.length > 0}>
            <ButtonNew
              type={'secondary'}
              borderWidth={1}
              height={40}
              borderColor={'#0070B6'}
              onPress={onApplicationRetry}
              title={'Retry'}
            />
          </ModBox>
        </Box>
      </ModBox>
      <ModBox {...styles.footer}>
        <Footer onSubmit={onSubmit} />
      </ModBox>
    </>
  )
}

export default AadharRedactionStatus
